import PageComponent from '../base/PageComponent';
import Filter from './Filter';
import List from './PropertyList';
import Map from './PropertyMap';
import Pager from './PropertyListingPager'
import {clustererStyles, markerStyles, markerInfoWindowTemplate} from './includes/PropertyListingModuleSettings';

export default class PropertyListingModule extends PageComponent {

    init() {
        this.initFilter();
        this.initMap();
        this.initPager();
    }

    initFilter() {
        this.list = new List(this.childElements('.property-listing__listings'));
        this.filter = new Filter(this.childElements('.property-listing__filter'));
        this.filter.onFilter = (filter) => this.filterResults(filter);
        this.filter.init();
    }

    initPager() {
        this.pager = new Pager(this.childElements('.pager'), this);
        this.pager.init();
    }

    initMap() {
        this.map = new Map(
            this.childElements('.property-listing__map'),
            clustererStyles,
            markerStyles,
            markerInfoWindowTemplate
        );
        this.map.minZoom = 6;
        this.map.maxZoom = 20;
        this.map.init();
    }

    onWindowResize() {
        this.equalizeColumn();
    }

    filterResults(filter) {
        this.addSpinner();

        var self = this;
        setTimeout(function () {
            $.get(self.element.data('json-url'), filter, (response) => {
                self.results = response;
                self.updateModuleViews(response);
            });
        }, 500);
    }


    updateModuleViews(response) {
        this.map.updateLocations(response.Locations);
        this.list.updateListings(response.Listings);
        this.initPager();

        // re-initiate pager because updateListings would have updated the pager dom elements
        // this.initPager();

        var images = $('.property-listing__img img'),
            noOfImages = images.length,
            noLoaded = 0,
            self = this;

        images.on('load', function () {
            noLoaded++;
            if (noOfImages === noLoaded) {
                self.equalizeColumn();
                self.element.removeClass('loading');
            }
        });

        if(response.HideForSale == 'hide'){
            $('.valCurrent').hide();
            $('.valSold').trigger('click')
        }else{
            $('.valCurrent').show();
        }

        this.childElements('.property-listing__listings').fadeTo(500,1);
    }

    addSpinner() {
        this.childElements('.property-listing__listings').fadeTo(500,0);
        let container = this.element;
        container.addClass('loading');
        setTimeout(function () {
            container.removeClass('loading');
        }, 5000);
    }

    equalizeColumn() {
        let tiles = this.childElements('.property-listing__item');
        setTimeout(function () {
            let maxHeight = Math.max.apply(Math, tiles.map(function () {
                return $(this).height();
            }));
            tiles.css('height', maxHeight);
            tiles.show();
        }, 500);
    }
}


// WEBPACK FOOTER //
// ./javascript/modules/PropertyListingModule.js